/* ============================================================
   SUCURSALES VÍA CARGO — Buscador de agencia más cercana
   Asset externo cargado con defer desde sections/sucursales-via-cargo.liquid.
   Se mueve fuera del inline <script> para evitar el contexto sandbox de
   Shopify (warning "addEventListener may not behave as expected") y para
   que el contenido NO dependa del JS (progressive enhancement: el HTML
   ya es visible sin este archivo; esto sólo agrega GPS / búsqueda).
   ============================================================ */
(function () {
  var root = document.getElementById('pvvcRoot');
  if (!root) return;

  var CFG = {
    jsonUrl: root.getAttribute('data-json'),
    wpp: (root.getAttribute('data-wpp') || '').replace(/[^\d]/g, ''),
    def: parseInt(root.getAttribute('data-default'), 10) || 5,
    max: parseInt(root.getAttribute('data-max'), 10) || 15
  };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var elGeo = document.getElementById('pvvcGeo');
  var elForm = document.getElementById('pvvcForm');
  var elInput = document.getElementById('pvvcInput');
  var elStatus = document.getElementById('pvvcStatus');
  var elResults = document.getElementById('pvvcResults');
  var elWa = document.getElementById('pvvcWa');
  var elCount = document.getElementById('pvvcCount');
  if (!elGeo || !elForm || !elInput || !elStatus || !elResults) return;

  var AG_KEY = 'pvvc_agencias_v1', LAST_KEY = 'pvvc_last_v1';
  var AG_TTL = 24 * 60 * 60 * 1000, LAST_TTL = 30 * 24 * 60 * 60 * 1000;

  var agencias = null, loading = null;
  var current = [], shown = 0, curLabel = '', lastSearch = null;
  var gridEl = null, moreEl = null;

  // mensaje de WhatsApp precargado
  if (elWa) elWa.href = 'https://wa.me/' + CFG.wpp + '?text=' +
    encodeURIComponent('Hola, no encuentro mi agencia de Vía Cargo más cercana, ¿me ayudan?');

  // ---------- utilidades ----------
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

  function haversine(la1, lo1, la2, lo2) {
    var R = 6371, p = Math.PI / 180;
    var dLa = (la2 - la1) * p, dLo = (lo2 - lo1) * p;
    var a = Math.sin(dLa / 2) * Math.sin(dLa / 2) +
            Math.cos(la1 * p) * Math.cos(la2 * p) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function fmtDist(km) {
    if (km < 1) return 'a ~' + (Math.round(km * 1000 / 10) * 10) + ' m';
    return 'a ~' + km.toFixed(1).replace('.', ',') + ' km';
  }
  function cleanPhone(t) {
    if (!t) return '';
    t = String(t).trim();
    if (!t) return '';
    var d = t.replace(/[^\d+]/g, '');
    return d.length >= 6 ? d : '';
  }
  function fmtHorarios(h) {
    if (!h) return [];
    h = String(h).replace(/\s+/g, ' ').trim();
    if (!h) return [];
    h = h.replace(/\s*(Lunes a Viernes|Lunes|Martes|Mi[eé]rcoles|Jueves|Viernes|S[áa]bados?|Domingos?|Feriados)\s*:/g, '\n$1:');
    return h.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
  }
  // Normaliza la dirección textual para que Google la geocodee bien:
  // saca "Nro./Nº/N°", el cross-street ("entre/esq/e/...") y "Local ..."
  function normDir(d) {
    return String(d || '')
      .replace(/N(?:ro|º|°)\.?/gi, ' ')   // "Nro." / "Nº" / "N°" (ASCII-safe)
      .replace(/\s(?:entre|esq\.?|esquina|e\/)\s.*$/i, '')       // cross-street
      .replace(/\s*[-,]?\s*Local\b.*$/i, '')                     // "Local ..." / "- Local ..."
      .replace(/\s+/g, ' ')
      .trim();
  }

  // ---------- cache ----------
  function readCache(key, ttl) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.ts || (Date.now() - o.ts) > ttl) return null;
      return o.data;
    } catch (e) { return null; }
  }
  function writeCache(key, data) {
    try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) {}
  }

  // ---------- carga de agencias ----------
  function loadAgencias() {
    if (agencias) return Promise.resolve(agencias);
    if (loading) return loading;
    var cached = readCache(AG_KEY, AG_TTL);
    if (cached && cached.length) {
      agencias = cached;
      if (elCount) animateCount(elCount, agencias.length);
      return Promise.resolve(agencias);
    }
    loading = fetch(CFG.jsonUrl)
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
      .then(function (raw) {
        var out = [];
        for (var i = 0; i < raw.length; i++) {
          var a = raw[i];
          var lat = parseFloat(a.Latitud), lng = parseFloat(a.Longitud);
          if (!isFinite(lat) || !isFinite(lng) || (lat === 0 && lng === 0)) continue;
          out.push({
            n: a.RazonSocial || 'Agencia Vía Cargo',
            d: a.Direccion || '',
            loc: a.Localidad || '',
            prov: a.Provincia || '',
            tel: cleanPhone(a.Telefono),
            lat: lat, lng: lng,
            hor: a.Horarios || '',
            rec: String(a['RecepcionEncomiendas '] || a['RecepcionEncomiendas'] || '').trim().toUpperCase() === 'SI'
          });
        }
        agencias = out;
        writeCache(AG_KEY, out);
        if (elCount) animateCount(elCount, out.length);
        return out;
      })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }

  function animateCount(el, target) {
    if (reduce) { el.textContent = target.toLocaleString('es-AR'); return; }
    var dur = 900, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var pr = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - pr, 3);
      el.textContent = Math.round(target * eased).toLocaleString('es-AR');
      if (pr < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // ---------- búsqueda ----------
  function runSearch(lat, lng, label, opts) {
    opts = opts || {};
    lastSearch = { lat: lat, lng: lng, label: label };
    showSkeleton();
    loadAgencias().then(function (list) {
      current = list.map(function (a) {
        var c = {}; for (var k in a) c[k] = a[k];
        c.dist = haversine(lat, lng, a.lat, a.lng);
        return c;
      }).sort(function (x, y) { return x.dist - y.dist; });
      shown = Math.min(CFG.def, current.length);
      renderResults(label, opts.scroll !== false);
      if (opts.save !== false) writeCache(LAST_KEY, { lat: lat, lng: lng, label: label });
    }).catch(function () {
      showError('No pudimos cargar las agencias. Revisá tu conexión y probá de nuevo.', true);
    });
  }

  function geocode(q) {
    var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=ar&q=' + encodeURIComponent(q);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (arr) {
        if (!arr || !arr.length) return null;
        return { lat: parseFloat(arr[0].lat), lng: parseFloat(arr[0].lon), label: q };
      });
  }

  // ---------- render ----------
  function cardHtml(a, idx) {
    var addr = normDir(a.d) + ', ' + a.loc + ', ' + a.prov + ', Argentina';
    var maps = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addr);
    var top = idx === 0;
    var hrs = fmtHorarios(a.hor);
    var hrsHtml = hrs.length ? '<div class="pvvc__hours">🕒 ' + hrs.map(esc).join('<br>') + '</div>' : '';
    var tel = a.tel ? '<a class="pvvc__btn pvvc__btn--call" href="tel:' + esc(a.tel) + '">📞 Llamar</a>' : '';
    var rec = a.rec ? '<span class="pvvc__badge">✓ Recibe encomiendas</span>' : '';
    var dir = esc(a.d) + (a.loc ? ' · ' + esc(a.loc) : '') + (a.prov ? ', ' + esc(a.prov) : '');
    return '' +
      '<article class="pvvc__card' + (top ? ' pvvc__card--top' : '') + '">' +
        (top ? '<span class="pvvc__crown">⭐ La más cercana</span>' : '') +
        '<div class="pvvc__card-head">' +
          '<h3 class="pvvc__card-name">' + esc(a.n) + '</h3>' +
          '<span class="pvvc__dist">' + esc(fmtDist(a.dist)) + '</span>' +
        '</div>' +
        '<p class="pvvc__addr">' + dir + '</p>' +
        rec + hrsHtml +
        '<div class="pvvc__actions">' +
          '<a class="pvvc__btn pvvc__btn--map" href="' + maps + '" target="_blank" rel="noopener">🗺️ Cómo llegar</a>' +
          tel +
        '</div>' +
      '</article>';
  }

  function appendCards(from, to) {
    var frag = document.createDocumentFragment();
    for (var i = from; i < to; i++) {
      var holder = document.createElement('div');
      holder.innerHTML = cardHtml(current[i], i);
      var el = holder.firstChild;
      if (!reduce) { el.style.animationDelay = ((i - from) * 60) + 'ms'; el.classList.add('pvvc-in'); }
      frag.appendChild(el);
    }
    gridEl.appendChild(frag);
  }

  function updateMore() {
    moreEl.innerHTML = '';
    if (shown < Math.min(current.length, CFG.max)) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pvvc__more'; b.textContent = 'Ver más agencias';
      b.addEventListener('click', function () {
        var prev = shown;
        shown = Math.min(shown + CFG.def, current.length, CFG.max);
        appendCards(prev, shown);
        updateMore();
      });
      moreEl.appendChild(b);
    } else if (current.length > CFG.max) {
      var p = document.createElement('p');
      p.className = 'pvvc__more-note';
      p.innerHTML = 'Te mostramos las ' + CFG.max + ' más cercanas. ¿No es ninguna? ' +
        '<a href="' + elWa.href + '" target="_blank" rel="noopener">Consultá por WhatsApp</a>.';
      moreEl.appendChild(p);
    }
  }

  function renderResults(label, doScroll) {
    curLabel = label || '';
    elStatus.hidden = true; elStatus.innerHTML = '';
    if (!current.length) {
      showError('No encontramos agencias cerca de ahí. Escribinos y te ayudamos a ubicarte.', false);
      return;
    }
    elResults.innerHTML =
      '<div class="pvvc__summary"><strong>' + current.length + '</strong> agencias' +
      (label ? (' cerca de <span>' + esc(label) + '</span>') : '') +
      ' · <small>distancias en línea recta (aprox.)</small></div>' +
      '<div class="pvvc__grid" id="pvvcGrid"></div>' +
      '<div class="pvvc__more-wrap" id="pvvcMoreWrap"></div>';
    elResults.hidden = false;
    gridEl = document.getElementById('pvvcGrid');
    moreEl = document.getElementById('pvvcMoreWrap');
    appendCards(0, shown);
    updateMore();
    if (doScroll) {
      try { elResults.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) {}
    }
  }

  // ---------- estados ----------
  function showSkeleton() {
    elResults.hidden = true; elResults.innerHTML = '';
    elStatus.hidden = false;
    elStatus.className = 'pvvc__status';
    var s = '<p class="pvvc__loading">Buscando agencias cerca tuyo…</p><div class="pvvc__grid">';
    for (var i = 0; i < 3; i++) s += '<div class="pvvc__skel"></div>';
    s += '</div>';
    elStatus.innerHTML = s;
  }
  function showError(msg, retry) {
    elResults.hidden = true; elResults.innerHTML = '';
    elStatus.hidden = false;
    elStatus.className = 'pvvc__status pvvc__status--msg';
    elStatus.innerHTML = '<p class="pvvc__err">' + esc(msg) + '</p>' +
      (retry ? '<button class="pvvc__retry" type="button" id="pvvcRetry">Reintentar</button>' : '') +
      '<a class="pvvc__wa pvvc__wa--sm" href="' + elWa.href + '" target="_blank" rel="noopener">💬 Consultar por WhatsApp</a>';
    if (retry) {
      var rb = document.getElementById('pvvcRetry');
      if (rb) rb.addEventListener('click', function () {
        if (lastSearch) runSearch(lastSearch.lat, lastSearch.lng, lastSearch.label);
      });
    }
  }

  // ---------- eventos ----------
  elGeo.addEventListener('click', function () {
    if (!navigator.geolocation) {
      showError('Tu navegador no permite ubicación automática. Está bien 👍 buscá escribiendo tu localidad arriba ↑', false);
      elInput.focus();
      return;
    }
    elGeo.classList.add('is-loading');
    showSkeleton();
    navigator.geolocation.getCurrentPosition(function (pos) {
      elGeo.classList.remove('is-loading');
      runSearch(pos.coords.latitude, pos.coords.longitude, 'tu ubicación');
    }, function (err) {
      elGeo.classList.remove('is-loading');
      var m = (err && err.code === 1)
        ? 'Está bien 👍 podés buscar escribiendo tu localidad arriba ↑'
        : 'No pudimos obtener tu ubicación. Buscá escribiendo tu localidad arriba ↑';
      showError(m, false);
      elInput.focus();
    }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
  });

  elForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = elInput.value.trim();
    if (q.length < 3) { elInput.focus(); return; }
    showSkeleton();
    geocode(q).then(function (g) {
      if (!g || !isFinite(g.lat)) {
        showError('No encontramos “' + esc(q) + '”. Probá con la localidad y provincia (ej: Moreno, Buenos Aires).', false);
        return;
      }
      runSearch(g.lat, g.lng, g.label);
    }).catch(function () {
      showError('No pudimos buscar esa dirección ahora. Probá de nuevo o usá tu ubicación 📍', false);
    });
  });

  // ---------- boot: prefetch + última búsqueda ----------
  function boot() {
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    idle(function () { loadAgencias().catch(function () {}); });

    var last = readCache(LAST_KEY, LAST_TTL);
    if (last && isFinite(last.lat) && isFinite(last.lng)) {
      // mostramos los resultados al toque, sin re-pedir GPS ni hacer scroll
      runSearch(last.lat, last.lng, last.label || 'tu última búsqueda', { save: false, scroll: false });
    }
  }
  boot();
})();
